import { useAuth } from "../auth/AuthContext";
import { listAccounts } from "../api/ledgerApi";
import { useAsyncData } from "../lib/useAsyncData";

export function useAccountOptions() {
  const { ensureFreshToken } = useAuth();
  return useAsyncData(() => ensureFreshToken().then((token) => listAccounts(token)), []);
}

export interface AccountSelectProps {
  id: string;
  label: string;
  value: string;
  onChange: (accountId: string) => void;
  required?: boolean;
}

/** `GET /ledger/accounts`-backed dropdown — used by bank reconciliation (§13.3) to pick
 * which GL account (e.g. "Cash") a statement import/match applies to. */
export function AccountSelect({ id, label, value, onChange, required }: AccountSelectProps) {
  const accountsState = useAccountOptions();
  const accounts = accountsState.data ?? [];

  return (
    <div className="sl-field">
      <label className="sl-field__label" htmlFor={id}>
        {label}
      </label>
      <select
        id={id}
        className="sl-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        disabled={accountsState.loading}
      >
        <option value="">Select an account…</option>
        {accounts.map((account) => (
          <option key={account.id} value={account.id}>
            {account.code} — {account.name}
          </option>
        ))}
      </select>
      {accountsState.error ? <p className="sl-field__error">{accountsState.error}</p> : null}
    </div>
  );
}
